import { render, staticRenderFns } from "./VBatchField.vue?vue&type=template&id=296d6bb2&"
import script from "./VBatchField.vue?vue&type=script&lang=js&"
export * from "./VBatchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports